/*GET ALL BOOKINGS */
export const GET_ALL_BOOKINGS = "GET_ALL_BOOKINGS"
export const GET_ALL_BOOKINGS_SUCCESS = "GET_ALL_BOOKINGS_SUCCESS"
export const GET_ALL_BOOKINGS_FAIL = "GET_ALL_BOOKINGS_FAIL"

// booking track
export const TRACK_BOOKING = "TRACK_BOOKING"
export const TRACK_BOOKING_SUCCESS = "TRACK_BOOKING_SUCCESS"
export const TRACK_BOOKING_FAIL = "TRACK_BOOKING_FAIL"

// get booking by booking no
export const GET_BOOKING_BY_BOOKING_NO = "GET_BOOKING_BY_BOOKING_NO"
export const GET_BOOKING_BY_BOOKING_NO_SUCCESS = "GET_BOOKING_BY_BOOKING_NO_SUCCESS"
export const GET_BOOKING_BY_BOOKING_NO_FAIL = "GET_BOOKING_BY_BOOKING_NO_FAIL"
export const GET_BOOKING_BY_BOOKING_NO_PROGRESS = "GET_BOOKING_BY_BOOKING_NO_PROGRESS"

// get booking by container wise
export const GET_BOOKING_BY_CONTAINER_WISE = "GET_BOOKING_BY_CONTAINER_WISE"
export const GET_BOOKING_BY_CONTAINER_WISE_FAIL = "GET_BOOKING_BY_CONTAINER_WISE_FAIL"
export const GET_BOOKING_BY_CONTAINER_WISE_SUCCESS = "GET_BOOKING_BY_CONTAINER_WISE_SUCCESS"